import { Injectable } from '@angular/core';
import { Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { Vacation } from '../../class/vacation';

@Injectable()
export class VacationService extends WebService {
  public getVacations(page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined)
      params.append('_page', String(page));
    else
      params.append('_page', '1');

    if (per_page !== null && per_page !== undefined)
      params.append('_limit', String(per_page));
    else
      params.append('_limit', '10');

    if (sort !== null && sort !== undefined)
      params.append('_sort', String(sort));

    if (query !== null && query !== undefined && query !== '')
      params.append('_q', String(query));

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach(element => {
        params.append(element.key, String(element.value));
      });
    }
    const options = new RequestOptions({search: params, headers: this.headers});

    return this.http.get( `${this.apiUrl}/vacations?${params}`, options);
  }

  public getVacation(contract_id:number): Observable<Response> {
    const options = new RequestOptions({ headers: this.headers});

    return this.http.get( `${this.apiUrl}/vacations/${contract_id}`,options);
  }

  public addVacation(body: Object): Observable<Response> {
    const options = new RequestOptions({ headers: this.headers});

    return this.http.post(`${this.apiUrl}/vacations`, JSON.stringify(body), options);
  }

  public updateVacation(body: Object, contract_id:number): Observable<Response> {
    const options = new RequestOptions({ headers: this.headers});

    return this.http.patch(`${this.apiUrl}/vacations/${contract_id}`, JSON.stringify(body), options);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/vacation/vacation.service.ts